import * as React from 'react';

interface IProps {
  w: number;
  h: number;
}
export const EvVikno: React.FunctionComponent<IProps> = ({ w, h }) => {
  return (
    <svg version="1.2" width={w} height={h} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 904 904">
      <path className="a" style={{ fill: '#fefefe' }} d="m65.9 62.8h775.3v775.3h-775.3z" />
      <path fillRule="evenodd" className="b" d="m842.1 839h-777.1v-777.1h777.1zm-775.4-1.8h773.6v-773.6h-773.6z" />
      <path className="greyHeader" style={{ fill: '#2b9a48' }} d="m83.4 820.6v-740.3h740.3v740.3z" />
      <path
        className="a"
        style={{ fill: '#fefefe' }}
        d="m384.4 261.3c0 21.3-17.2 38.6-38.6 38.6-21.3 0-38.6-17.3-38.6-38.6 0-21.4 17.3-38.7 38.6-38.7 21.4 0 38.6 17.3 38.6 38.7z"
      />
      <path
        className="a"
        style={{ fill: '#fefefe' }}
        d="m320 640.5v123.2h-21.4v-37.1h-129v37.1h-21.4v-626.5h21.4v37.1h129v-37.1h21.4v80.3c-9.7 5.8-17.2 14.6-21.4 25.1v-46.9h-129v84.8h129v-0.6c4.2 10.6 11.7 19.4 21.4 25.1v29.7l-21.4 21.6v-54.4h-129v84.8h6.1c-4.3 5-7.4 11.9-7.4 21 0 3.3 0.5 6.3 1.3 9v76.1h129v-51.6h9.8l11.6-11.2v119.1l-21.4 22.1v-56.9h-129v84.7h110.1c-2.2 7.5-1.9 14.8 0.7 21.5h-110.8v84.7h129v-65.8c4.5 2 8.7 2.6 12 2.6 3.3 0 6.5-0.6 9.4-1.5z"
      />
      <path
        fillRule="evenodd"
        className="a"
        style={{ fill: '#fefefe' }}
        d="m758.9 490.2h-296.5l-132.6 129.5c0 0-16.8 20.1-33.2 3.7-16.4-16.4 4.8-37.6 4.8-37.6l104.4-107.8v-92.1l-27.8-29.3-74.5 72.4h-99.7c0 0-23.3-4-23.3-21.3 0-17.3 16.9-20.7 16.9-20.7l88-0.1 120.4-121.5v-128.2h353.1zm-28.5-324.6h-296.1v93.1c15.6 0 38.1 0 62.1 0 44.7 0 40.3 28.4 40.3 28.4 0 0 0 55.9 0 70.4 0 14.6-6.9 5.6-22.7-10.1-15.7-15.8-17.2-21-17.2-21l-0.3-23.8h-48.5l149.3 150.8h-69l-11.8-16.1-25 24.4h238.9zm-296.1 283.1l15.7-16.3-15.7-16.6z"
      />
    </svg>
  );
};
